import { ChartColumnIcon, ChartPieIcon, TrendingDownIcon } from "lucide-react";

import { ChartFormatEnum } from "@/__generated__/graphql";
import { ReportsViewMetricWidget } from "@/app/app/_/views/ReportsView/ReportsViewWidget/ReportsViewMetricWidget";
import { ReportsViewCard } from "@/app/app/_/views/ReportsView/ReportsViewCard";
import { Chart } from "@/components/organisms/Chart";
import { ILLUSTRATION_COLORS } from "@/constants/values";
import { cn } from "@/components/ui/utils";

export function SliceAndDiceFeature() {
  const { color1, color2 } = ILLUSTRATION_COLORS;
  return {
    left: {
      title: "Slice & Dice",
      description:
        "A dashboard is worth a 1,000 rows. Break down all your data into reports and charts.",
      button: {
        text: "Learn more",
        onClick: () => {},
      },
    },
    center: {
      backgroundPattern: "dots",
      renderChildren: () => {
        return (
          <div
            // transform: "translateX(32px)",
            className="grid grid-cols-[1fr_1fr] gap-8 auto-rows-auto grid-flow-row"
          >
            <ReportsViewCard title="Cash in" className="pb-8">
              <ReportsViewMetricWidget value={1000} isLoading={false} />
            </ReportsViewCard>
            <ReportsViewCard title="Cash out">
              <ReportsViewMetricWidget value={1000} isLoading={false} />
            </ReportsViewCard>
            <ReportsViewCard style={{ gridColumn: "1 / span 2" }}>
              <Chart
                size="sm"
                data={{
                  __typename: "ChartData",
                  title: "Bank accounts",
                  series: ["Balance"],
                  labelFormat: ChartFormatEnum.String,
                  labelAxis: "",
                  valueAxis: "",
                  valueFormat: ChartFormatEnum.Currency,
                  points: [
                    {
                      __typename: "ChartPoint",
                      label: "RBC",
                      values: [
                        {
                          __typename: "ChartSeriesPoint",
                          key: "Balance",
                          value: "2450",
                        },
                      ],
                    },
                    {
                      __typename: "ChartPoint",
                      label: "CIBC",
                      values: [
                        {
                          __typename: "ChartSeriesPoint",
                          key: "Balance",
                          value: "1920",
                        },
                      ],
                    },
                    {
                      __typename: "ChartPoint",
                      label: "Questrade",
                      values: [
                        {
                          __typename: "ChartSeriesPoint",
                          key: "Balance",
                          value: "2030",
                        },
                      ],
                    },
                  ],
                }}
                type="pie"
              />
            </ReportsViewCard>
          </div>
        );
      },
    },
    right: {
      renderChildren: () => {
        return <>{/* children */}</>;
      },
      renderHoverAnimation: (isHovering) => {
        return (
          <>
            <div
              // width: "128px",
              // height: "64px",
              className="absolute z-100 -top-4 -bottom-4 left-10 right-10 bg-background [border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] p-4 gap-1 rounded-sm flex flex-col justify-start shadow-sm"
            >
              <div
                className={cn(
                  !isHovering ? "w-16" : "w-20",
                  "min-h-2 rounded-lg [transition:0.3s_all]",
                  isHovering
                    ? "bg-[color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]"
                    : "bg-[color-mix(in_srgb,var(--border)_20%,var(--muted-foreground)_80%)]",
                  "z-100",
                )}
              />
              <div
                className={cn(
                  !isHovering ? "w-24" : "w-27",
                  "min-h-2 rounded-lg [transition:0.3s_all]",
                  isHovering
                    ? "bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]"
                    : "bg-[color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]",
                  "z-100",
                )}
              />
              <div
                className={cn(
                  !isHovering ? "w-20.5" : "w-16",
                  "min-h-2 rounded-lg [transition:0.3s_all]",
                  isHovering
                    ? "bg-[color-mix(in_srgb,var(--border)_50%,var(--muted-foreground)_50%)]"
                    : "bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)]",
                  "z-100",
                )}
              />
              <div
                className={cn(
                  !isHovering ? "w-24" : "w-20",
                  "min-h-2 rounded-lg [transition:0.3s_all] bg-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground)_20%)] z-100",
                )}
              />
              <div className="mt-4 flex justify-between items-center">
                <div className="[border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-md flex justify-center items-center min-w-10 min-h-10 max-w-10 max-h-10 shadow-sm">
                  <ChartPieIcon
                    size="1em"
                    color={!isHovering ? color1 : color2}
                    style={{ transition: "0.3s all" }}
                  />
                </div>
                <div className="[border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-md flex justify-center items-center min-w-10 min-h-10 max-w-10 max-h-10 shadow-sm">
                  <ChartColumnIcon
                    size="1em"
                    color={!isHovering ? color1 : color2}
                    style={{ transition: "0.3s all" }}
                  />
                </div>
                <div className="[border-width:1px] [border-style:solid] border-[color-mix(in_srgb,var(--border)_80%,var(--muted-foreground))] rounded-md flex justify-center items-center min-w-10 min-h-10 max-w-10 max-h-10 shadow-sm">
                  <TrendingDownIcon
                    size="1em"
                    color={!isHovering ? color1 : color2}
                    style={{ transition: "0.3s all" }}
                  />
                </div>
              </div>
            </div>
          </>
        );
      },
      backgroundPattern: "grid",
    },
  };
}
